import { TrackingService } from '../services/TrackingService'
import type { Traits } from '../types'
import { CoreIdentify } from '../events/CoreIdentify'

function useCoreIdentify(): (params: Traits, userId?: string) => void {
  return function trackCoreIdentify(params: Traits, userId?: string): void {
    const coreIdentifyEvent = new CoreIdentify({
      traits: params,
      userId,
    })

    TrackingService.track(coreIdentifyEvent)
  }
}

export default useCoreIdentify
